import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.userService.getUser();
    let authReq = req;
    const urlMatches = req.url.includes('api/');

    if (user && urlMatches) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${user.idToken}`,
        },
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleExpiredToken();
        }
        return throwError(() => new Error(error.message));
      })
    );
  }

  private handleExpiredToken() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/']); // Cambia '/443' por una ruta válida como '/login'
  }
}
